import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getAttributionFields } from "../lib/attribution";

const HS_SUBMIT_URL =
  "https://api.hsforms.com/submissions/v3/integration/submit/342523689/2fd30835-db60-4630-b3d9-2b02f8e0f1c5";

const getCookie = (name) => {
  const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return m ? decodeURIComponent(m[1]) : "";
};

const PAGE_TITLE =
  "Whole Life Insurance for Business Owners | Mayker Financial Group";
const PAGE_DESC =
  "Corporate-owned whole life insurance for incorporated business owners in BC. Tax-sheltered growth, estate planning and succession funding. Independent advice — iA, Canada Life & more.";

const PAGE_HTML = `
<style>
  #mayker-lp{
    --navy:#16324f; --navy-dark:#0e2338; --gold:#c9a227; --gold-light:#e6c96a;
    --ink:#22303c; --muted:#5c6b78; --bg:#f7f8fa; --white:#fff;
    font-family:Georgia,'Times New Roman',serif;color:var(--ink);background:var(--bg);line-height:1.6;
  }
  #mayker-lp *{margin:0;padding:0;box-sizing:border-box}
  #mayker-lp .sans{font-family:'Helvetica Neue',Arial,sans-serif}
  #mayker-lp .wrap{max-width:1080px;margin:0 auto;padding:0 24px}
  #mayker-lp header{background:var(--white);border-bottom:1px solid #e5e8ec;padding:18px 0}
  #mayker-lp header .wrap{display:flex;justify-content:space-between;align-items:center}
  #mayker-lp .logo{font-weight:700;font-size:1.25rem;color:var(--navy);letter-spacing:.02em}
  #mayker-lp .logo span{color:var(--gold)}
  #mayker-lp .phone{font-size:1rem;color:var(--navy);text-decoration:none;font-weight:600}
  #mayker-lp .hero{background:linear-gradient(160deg,var(--navy) 0%,var(--navy-dark) 100%);color:var(--white);padding:72px 0 64px}
  #mayker-lp .hero .wrap{display:grid;grid-template-columns:1.15fr .85fr;gap:48px;align-items:center}
  #mayker-lp .eyebrow{color:var(--gold-light);text-transform:uppercase;letter-spacing:.14em;font-size:.8rem;margin-bottom:14px}
  #mayker-lp h1{font-size:2.4rem;line-height:1.2;margin-bottom:18px;font-weight:600}
  #mayker-lp .hero p.lead{font-size:1.125rem;color:#d8e0e8;margin-bottom:8px}
  #mayker-lp .hero ul{list-style:none;margin:20px 0 0}
  #mayker-lp .hero li{padding-left:28px;position:relative;margin-bottom:10px;color:#e8edf2}
  #mayker-lp .hero li:before{content:"✓";position:absolute;left:0;color:var(--gold);font-weight:700}
  #mayker-lp .card{background:var(--white);border-radius:10px;box-shadow:0 10px 30px rgba(14,35,56,.25);padding:32px;color:var(--ink)}
  #mayker-lp .card h2{font-size:1.3rem;color:var(--navy);margin-bottom:6px}
  #mayker-lp .card p.sub{font-size:.9rem;color:var(--muted);margin-bottom:18px}
  #mayker-lp .field{margin-bottom:14px}
  #mayker-lp .field label{display:block;font-size:.85rem;font-weight:600;margin-bottom:5px;color:var(--navy)}
  #mayker-lp .field input,#mayker-lp .field select{width:100%;padding:11px 12px;border:1px solid #cdd5dd;border-radius:6px;font-size:1rem;background:#fbfcfd}
  #mayker-lp .btn{display:block;width:100%;background:var(--gold);color:var(--navy-dark);border:none;border-radius:6px;padding:14px;font-size:1.05rem;font-weight:700;cursor:pointer;transition:background .15s}
  #mayker-lp .btn:hover{background:var(--gold-light)}
  #mayker-lp .fine{font-size:.75rem;color:var(--muted);margin-top:10px;text-align:center}
  #mayker-lp section{padding:64px 0}
  #mayker-lp .kicker{color:var(--gold);text-transform:uppercase;letter-spacing:.12em;font-size:.78rem;margin-bottom:10px}
  #mayker-lp h2.section-title{font-size:1.8rem;color:var(--navy);margin-bottom:14px}
  #mayker-lp .section-intro{max-width:720px;color:var(--muted);margin-bottom:36px}
  #mayker-lp .grid3{display:grid;grid-template-columns:repeat(3,1fr);gap:24px}
  #mayker-lp .tile{background:var(--white);border:1px solid #e5e8ec;border-radius:10px;padding:28px}
  #mayker-lp .tile .num{font-size:.8rem;color:var(--gold);font-weight:700;letter-spacing:.1em;margin-bottom:8px}
  #mayker-lp .tile h3{color:var(--navy);font-size:1.1rem;margin-bottom:8px}
  #mayker-lp .tile p{font-size:.95rem;color:var(--muted)}
  #mayker-lp .split{display:grid;grid-template-columns:1fr 1fr;gap:48px;align-items:start}
  #mayker-lp .split h3{color:var(--navy);font-size:1.15rem;margin:22px 0 6px}
  #mayker-lp .split p{color:var(--muted);font-size:.98rem}
  #mayker-lp .band{background:var(--navy);color:var(--white);text-align:center;padding:56px 0}
  #mayker-lp .band h2{font-size:1.7rem;margin-bottom:10px}
  #mayker-lp .band p{color:#d8e0e8;margin-bottom:24px}
  #mayker-lp .band .btn{display:inline-block;width:auto;padding:14px 44px;text-decoration:none}
  #mayker-lp footer{background:var(--navy-dark);color:#9fb0bf;font-size:.85rem;padding:36px 0}
  #mayker-lp footer .wrap{display:flex;flex-direction:column;gap:10px}
  @media(max-width:860px){
    #mayker-lp .hero .wrap,#mayker-lp .split{grid-template-columns:1fr}
    #mayker-lp .grid3{grid-template-columns:1fr}
    #mayker-lp h1{font-size:1.9rem}
  }
</style>
<header>
  <div class="wrap">
    <div class="logo">MAYKER <span>FINANCIAL GROUP</span></div>
    <a class="phone sans" href="tel:+12505169772">250-516-9772</a>
  </div>
</header>
<section class="hero">
  <div class="wrap">
    <div>
      <div class="eyebrow sans">For Incorporated Business Owners in BC</div>
      <h1>Your corporation's retained earnings are being taxed twice. There's a better place for them.</h1>
      <p class="lead">Corporate-owned participating whole life turns surplus corporate cash into tax-sheltered growth, a larger estate for your family, and a funded succession plan.</p>
      <ul class="sans">
        <li>Shelter passive investment growth from corporate tax</li>
        <li>Move value out of your company tax-efficiently at death via the Capital Dividend Account</li>
        <li>Fund terminal taxes &amp; equalize your estate between children in and out of the business</li>
        <li>Independent advice — we shop iA, Canada Life, and more. No sales pressure.</li>
      </ul>
    </div>
    <div class="card sans">
      <h2>Book a Free Owner Strategy Call</h2>
      <p class="sub">15 minutes. No obligation. We'll tell you honestly whether this fits your situation.</p>
      <form action="#" method="POST">
        <div class="field">
          <label for="name">Name</label>
          <input type="text" id="name" name="name" required>
        </div>
        <div class="field">
          <label for="email">Email</label>
          <input type="email" id="email" name="email" required>
        </div>
        <div class="field">
          <label for="phone">Phone</label>
          <input type="tel" id="phone" name="phone" required>
        </div>
        <div class="field">
          <label for="situation">Which best describes you?</label>
          <select id="situation" name="situation">
            <option>Incorporated — retained earnings building up</option>
            <option>Planning my exit / succession in the next 10 years</option>
            <option>Estate planning for my family</option>
            <option>Just exploring options</option>
          </select>
        </div>
        <button class="btn" type="submit">Get My Free Strategy Call</button>
        <p class="fine">Your information is never sold or shared.</p>
      </form>
    </div>
  </div>
</section>
<section>
  <div class="wrap">
    <div class="kicker sans">The Problem</div>
    <h2 class="section-title">Passive income inside your corporation is punished</h2>
    <p class="section-intro">Investment income earned inside a CCPC is taxed at roughly 50%, and once passive income passes $50,000/year it starts grinding away your small business deduction. Leaving surplus cash in GICs and index funds inside the company is one of the most expensive "safe" decisions a business owner can make.</p>
    <div class="grid3 sans">
      <div class="tile">
        <div class="num">STEP 1</div>
        <h3>Redirect surplus cash</h3>
        <p>Your corporation pays premiums into a participating whole life policy it owns — using dollars that would otherwise sit in passively-taxed investments.</p>
      </div>
      <div class="tile">
        <div class="num">STEP 2</div>
        <h3>Growth is tax-sheltered</h3>
        <p>Cash value grows inside the policy without annual passive-income tax, and doesn't erode your small business deduction. You can access it during your lifetime if needed.</p>
      </div>
      <div class="tile">
        <div class="num">STEP 3</div>
        <h3>Exit through the CDA</h3>
        <p>At death, the insurance payout credits your Capital Dividend Account — allowing value to flow to your estate largely tax-free instead of as a heavily-taxed dividend.</p>
      </div>
    </div>
  </div>
</section>
<section style="background:#fff">
  <div class="wrap split">
    <div>
      <div class="kicker sans">Estate &amp; Succession</div>
      <h2 class="section-title">Built for owners thinking about what's next</h2>
      <h3>Fund the terminal tax bill</h3>
      <p>When you die, CRA treats your shares as sold. Without liquidity, your family may have to sell the business or its assets to pay the tax. Insurance creates the cash exactly when it's needed.</p>
      <h3>Equalize your estate</h3>
      <p>One child in the business, one not? A policy lets you leave the company to one and equivalent value to the other — without splitting ownership or forcing a sale.</p>
      <h3>Exit on your terms</h3>
      <p>Whether you sell, wind down, or hand over the keys, permanent coverage locked in during your 40s and 50s is dramatically cheaper than anything available later — and the cash value is yours regardless of what the business does.</p>
    </div>
    <div>
      <div class="kicker sans">Why Mayker</div>
      <h2 class="section-title">Independent. Local. No pressure.</h2>
      <p>Mayker Financial Group is an independent advisory practice in British Columbia. We're not tied to any one insurer — we compare participating whole life products from iA Financial, Canada Life, and other leading Canadian carriers, and we'll tell you plainly if this strategy doesn't fit your situation.</p>
      <h3>Who this is for</h3>
      <p>Incorporated business owners, typically 45–65, with retained earnings or consistent surplus cash flow, who want their corporate dollars working harder for their family's future.</p>
      <h3>Who this is NOT for</h3>
      <p>If your corporation needs its cash for operations, or you're looking for a quick-return investment, we'll say so on the first call. Whole life is a long-term planning tool — not a trading strategy.</p>
    </div>
  </div>
</section>
<section class="band">
  <div class="wrap">
    <h2>Find out what your retained earnings could really do</h2>
    <p class="sans">A 15-minute call. Real numbers for your situation. Zero obligation.</p>
    <a class="btn sans" href="#top" onclick="document.getElementById('name').focus();return false;">Book My Free Strategy Call</a>
  </div>
</section>
<footer class="sans">
  <div class="wrap">
    <div>Mayker Financial Group · British Columbia, Canada · <a href="tel:+12505169772" style="color:#c9d4de">250-516-9772</a></div>
    <div>Insurance products provided through licensed advisors. This page is general information, not tax advice — strategies described depend on individual circumstances. Consult your accountant regarding corporate tax planning.</div>
  </div>
</footer>
`;

export default function BusinessOwnersPage() {
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = PAGE_TITLE;
    const meta = document.querySelector('meta[name="description"]');
    const prevDesc = meta ? meta.getAttribute("content") : null;
    if (meta) meta.setAttribute("content", PAGE_DESC);
    window.scrollTo(0, 0);

    const root = ref.current;
    const form = root && root.querySelector("form");
    if (!form) return;

    const onSubmit = async (e) => {
      e.preventDefault();
      const btn = form.querySelector('button[type="submit"]');
      const val = (id) => (root.querySelector("#" + id)?.value || "").trim();
      const fullName = val("name");
      const email = val("email");
      const phone = val("phone");
      const situation = val("situation");
      if (!fullName || !email || !phone) return;

      const parts = fullName.split(/\s+/);
      const firstname = parts.shift() || fullName;
      const lastname = parts.join(" ");

      if (btn) { btn.disabled = true; btn.textContent = "Submitting…"; }

      const fields = [
        { objectTypeId: "0-1", name: "firstname", value: firstname },
        { objectTypeId: "0-1", name: "lastname", value: lastname },
        { objectTypeId: "0-1", name: "email", value: email },
        { objectTypeId: "0-1", name: "phone", value: phone },
        {
          objectTypeId: "0-1",
          name: "message",
          value: `Business Owners landing page — Situation: ${situation}\nSubmitted from: ${window.location.href}`,
        },
        { objectTypeId: "0-1", name: "lead_source_page", value: window.location.origin + window.location.pathname },
        ...getAttributionFields(),
      ];
      const context = { pageUri: window.location.href, pageName: PAGE_TITLE };
      const hutk = getCookie("hubspotutk");
      if (hutk) context.hutk = hutk;

      try {
        const res = await fetch(HS_SUBMIT_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ fields, context }),
        });
        if (res.ok) {
          navigate("/thank-you");
          return;
        }
      } catch {
        // fall through to re-enable + message
      }
      if (btn) { btn.disabled = false; btn.textContent = "Get My Free Strategy Call"; }
      window.alert("Something went wrong. Please call us at 250-516-9772.");
    };

    form.addEventListener("submit", onSubmit);
    return () => {
      form.removeEventListener("submit", onSubmit);
      if (meta && prevDesc !== null) meta.setAttribute("content", prevDesc);
    };
  }, [navigate]);

  return <div id="mayker-lp" ref={ref} data-testid="business-owners-page" dangerouslySetInnerHTML={{ __html: PAGE_HTML }} />;
}
